export { default as withRGPortlet, SET_CONFIG } from './withRGPortlet';
